/* eslint-disable import/prefer-default-export */
import { useRoute } from 'vue-router';
import { useProduct } from '@modules/product';
import { useProductType } from '@composables/useProductType';
import { useUpcPreselectConsolidated } from './useUpcPreselectConsolidated';
import { useUpcPreselectBasic } from './useUpcPreselectBasic';

export const useUpcPreselect = () => {
  const { productId } = useProduct();
  const { query } = useRoute();

  /**
   * @type {string}
   */
  const preselectedUpc = query?.upc_ID;

  if (!preselectedUpc) {
    return;
  }

  const { isConsolidatedMaster } = useProductType({ productId });

  if (isConsolidatedMaster) {
    useUpcPreselectConsolidated(preselectedUpc);
    return;
  }
  useUpcPreselectBasic(preselectedUpc);
};
